export default () => localStorage.getItem('escenaTheater');



// WEBPACK FOOTER //
// ./src/utils/GetTheaterId.js